import EncryptionUtils from "./encrypt";
import {
  START_LOADER,
  STOP_LOADER,
  USER_LOGIN_REFRESH_SUCCESS,
  USER_LOGOUT,
} from "./types";
import * as jwt from "jsonwebtoken";

const PROXY_PATH =
  process.env.REACT_APP_API_PROXY_PATH ||
  "/v2/dit-uat-proxy/25UAT/SmartService.svc";
export const BASE_URL = (process.env.REACT_APP_API_URL || "") + PROXY_PATH;
export const FILE_URL =
  (process.env.REACT_APP_API_FILE_UPLOAD || "") +
  "/image-proxy/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave";

export const CART_URL =
  process.env.REACT_APP_CART_API_URL ||
  "https://ditapp-uat.kfintech.com/api/ct";
export const NCT_URL_NEW =
  process.env.REACT_APP_NCT_API_URL ||
  "https://ditapp-uat.kfintech.com/api/nct";

export const NCT_URL_OLD =
  (process.env.REACT_APP_API_URL || "") +
  "/image-proxy/ktrackgo/SmartService.svc/ktrack_uploaded_PdfSave_NCT";

export const FEED_BACK_URL =
  "https://mfs.kfintech.com/KTRACKAPI/SmartService.svc";
const NEW_NPS_SUBSCRIBER_URL =
  process.env.REACT_APP_NPS_URL ||
  "https://clientwebsitesuat2.kfintech.com/nps-api/nps";
export const CHEQUE_UPLOAD =
  "https://clientwebsitesuat3.kfintech.com/25UAT/Ktrackgo/SmartService.svc/PennyDropChequeUpload_New";
export const PHYGITAL_REPORT_URL =
  "https://mfs.kfintech.com/phygital/api/v1/phygital";
const FETCH_FAILED = "Failed to fetch";
const PUBLIC_URL = process.env.PUBLIC_URL || "";

const isDev = PUBLIC_URL !== "/dit";

async function invokeNpsAPI(endpoint, config, auth_token) {
  const { isNps, isNpsFile, ...others } = config;
  const HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const headers = !!auth_token
    ? { ...HEADERS, authorization: `Bearer ${auth_token}` }
    : { ...HEADERS };
  if (isNpsFile) {
    const body = others.body;
    const response = await fetch(BASE_URL + "/nps", {
      body: JSON.stringify({ body, endPoint: endpoint }),
      method: "POST",
      headers: headers,
      json: true,
    });
    const data = await response.json();
    return data;
  }

  if (isNps) {
    const body = JSON.stringify({
      ...others.body,
    });

    const response = await fetch(BASE_URL + "/nps", {
      body: JSON.stringify({ body, endPoint: endpoint }),
      method: "POST",
      headers: headers,
    });

    const data = await response.json();

    return data;
  }
}

async function invokeAPI(endpoint, config, auth_token, next) {
  const {
    isFile,
    isNct,
    isTrackApi,
    isNps,
    isNpsFile,
    isNctNew,
    isCart,
    isReport,
    isLogin: isL,
    isAuth,
    ...others
  } = config;
  const isLogin = isL || isAuth;
  const DEFAULT_HEADERS =
    !!isFile || !!isTrackApi
      ? {
          Accept: "application/json",
          "Content-Type": "text/plain",
        }
      : {
          Accept: "application/json",
          "Content-Type": "application/json",
        };

  const headers = !!auth_token
    ? { ...DEFAULT_HEADERS, authorization: `Bearer ${auth_token}` }
    : { ...DEFAULT_HEADERS };

  const updatedConfig = { ...others, headers };

  const response = await fetch(
    isNctNew
      ? NCT_URL_NEW + endpoint
      : isNct
      ? NCT_URL_OLD + endpoint
      : isCart
      ? CART_URL + endpoint
      : isFile
      ? FILE_URL
      : isTrackApi
      ? FEED_BACK_URL + endpoint
      : isReport
      ? PHYGITAL_REPORT_URL + endpoint
      : BASE_URL + endpoint,
    updatedConfig
  );

  const responseData = await response.json();

  const { encryptedBody } = responseData;
  const body = encryptedBody
    ? JSON.parse(new EncryptionUtils().decrypt(encryptedBody))
    : responseData;

  const isValidLogin = validateLogin({
    isLogin,
    loginPayload: body,
    responseBody: responseData,
  });

  if (!isValidLogin) {
    next({ type: USER_LOGOUT });
    return;
  }

  if (response.status === 401) {
    next({
      type: USER_LOGOUT,
    });
    throw new Error("Unauthorized Request");
  }
  if (response.status === 413) {
    throw new Error(
      "Upload file size too large. Try uploading a smaller file less than 24 MB or change the file format."
    );
  }
  if (response.status >= 400 && isCart) {
    throw new Error(body.message);
  }
  if (response.status >= 400) {
    const { message = "", error } = body;
    throw new Error(message || error || "Something Went Wrong");
  }

  const data = isFile || isTrackApi ? JSON.parse(body) : body;

  const { Dtinformation, Table, Table1 } = data;
  if (!!Dtinformation || !!Table || !!Table1) {
    const [info] = Dtinformation || Table || Table1;
    const errorCode = !!info
      ? typeof info.Error_code !== "undefined"
        ? info.Error_code
        : info.Error_Code
      : "";
    if (typeof errorCode === "undefined" && !!Dtinformation.length) {
      return data;
    } else if (+errorCode !== 0) {
      throw info.Error_Message;
    }
    return data;
  } else if (!!data) {
    return data;
  }
}

async function invokeNewSubscriberAPI(endpoint, config, auth_token) {
  const { method, body, isFixtureEnabled, fixtureJson } = config;
  const requestOptions = {
    method,
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${auth_token}`,
    },
    body,
  };

  if (isFixtureEnabled) {
    const response = await fetch(`/fixtures/${fixtureJson}`);
    return response.json();
  }

  const response = await fetch(
    NEW_NPS_SUBSCRIBER_URL + endpoint,
    requestOptions
  );
  const data = await response.json();
  return data;
}
export const CALL_API = Symbol("Call API");

const apiMiddleware = (store) => (next) => async (action) => {
  try {
    if (typeof action[CALL_API] === "undefined") {
      return next(action);
    }

    let {
      url,
      method,
      types = [],
      showLoader = true,
      body = undefined,
      params,
      ikyc = false,
      isNps = false,
      isNpsFile = false,
      isNct = false,
      addedparams,
      isReport = false,
      isFile = false,
      isTrackApi = false,
      isLogin: isL = false,
      isNpsSubscriber = false,
      savePayload = false,
      enableFixture = false,
      json = "",
      isNctNew = false,
      isCart = false,
      isAuthTable = false,
      isAuth,
      skipEncode = false,
    } = action[CALL_API];
    const isLogin = isAuth || isL;
    if (isDev) {
      console.log("**********************");
      console.log("URL=>", url);
    }

    const [requestType, successType] = types;
    const { authReducer } = store.getState();

    const isUserLoggedOut = store.getState().authReducer?.userLoggedOut;

    if (isUserLoggedOut && isNps) {
      return { body: '{"Code":"unauthorized request"}' };
    }

    if (isUserLoggedOut && !isLogin) {
      return { Dtinformation: [], DtData: [] };
    }

    requestType && next({ type: requestType });

    if (showLoader) {
      next({ type: START_LOADER });
    }

    if (!isLogin) {
      await validateAndRefreshToken(next, store);
    }

    if (enableFixture && json) {
      const response = await fetch(`${PUBLIC_URL}/fixtures/${json}`);
      return await response.json();
    }

    if (isNps || isNpsFile) {
      const responseBody = invokeNpsAPI(
        url,
        {
          method,
          body,
          isNps,
          isNpsFile,
        },
        authReducer.auth_token
      );

      successType &&
        next({
          body: {
            ...responseBody,
          },
          type: successType,
        });

      return responseBody;
    }

    const queryParams = new URLSearchParams();

    for (const param in params) {
      if (skipEncode) {
        const value = params[param] || "";
        queryParams.set(param, encodeURIComponent(value));
      } else if (isAuthTable && param === "transflag") {
        queryParams.set(param, encodeURIComponent(params[param]));
      } else if (params[param]) {
        queryParams.set(param, encodeURIComponent(btoa(params[param])));
      }
    }

    const stringParametrs = queryParams.toString();

    if (isNpsSubscriber) {
      const responseBody = await invokeNewSubscriberAPI(
        url + queryParams + `?isWeb = true`,
        {
          method,
          body: JSON.stringify(body),
        },
        authReducer.auth_token
      );

      successType &&
        next({
          body: savePayload ? body : { ...responseBody },
          type: successType,
        });
      return responseBody;
    }

    const responseBody = await invokeAPI(
      url +
        "?" +
        `${stringParametrs}&isWeb=true&Requid=${
          !!authReducer.userId
            ? encodeURIComponent(btoa(authReducer.userId))
            : ""
        }&Reqsource=${encodeURIComponent(
          btoa("WEBILE")
        )}&APKVer=${encodeURIComponent(btoa("2.0"))}`,
      {
        method,
        body: isNctNew
          ? JSON.stringify({
              encryptedBody: new EncryptionUtils().encrypt(
                JSON.stringify(body)
              ),
            })
          : JSON.stringify(body),
        redirect: "manual",
        isFile,
        isNct,
        isTrackApi,
        isNctNew,
        isCart,
        isReport,
      },
      authReducer.auth_token,
      next
    );

    if (isDev) {
      console.log("response=>");
      console.log(responseBody);
      console.log("************************");
    }

    successType &&
      next({
        body: responseBody,
        type: successType,
      });

    return responseBody;
  } catch (error) {
    console.trace(error);
    if (typeof error === "string") {
      throw new Error(error);
    }
    if (
      error instanceof Error &&
      ["AUTH_FAILED", "TIMED_OUT"].includes(error.cause)
    ) {
      alert(error);
      return;
    }
    if (error.message !== FETCH_FAILED) {
      throw error;
    }
  } finally {
    if (typeof action[CALL_API] === "undefined") {
      return;
    }
    const { showLoader = true } = action[CALL_API];
    if (showLoader) {
      next({ type: STOP_LOADER });
    }
  }
};

export default apiMiddleware;

function validateLogin({ isLogin, loginPayload, responseBody }) {
  if (!isLogin) return true;
  const { username } = loginPayload;
  const { user, arn } = jwt.decode(responseBody.token);
  return decrypt(username) === user && arn === responseBody?.DtData[0]?.ARNCode;
}
function decrypt(text) {
  const decodedString = atob(text);
  const encrpyted1 = decodedString.slice(11, -16);
  const encrpyted = atob(encrpyted1);
  return encrpyted;
}

async function validateAndRefreshToken(next, store) {
  const authorizationToken = store.getState().authReducer?.auth_token;
  const { exp } = jwt.decode(authorizationToken);
  const FIVE_MINUTES = 5 * 60 * 1000;

  const diff = Math.floor(
    new Date(exp * 1000).getTime() - new Date().getTime()
  );
  if (diff < 0) {
    next({ type: USER_LOGOUT });
    throw new Error(
      "Your active session has timeout. Request you to re-login",
      {
        cause: "TIMED_OUT",
      }
    );
  }

  if (diff > FIVE_MINUTES) return;

  const response = await invokeAPI(
    "/refresh_token",
    { method: "GET" },
    authorizationToken
  );

  if (response?.token) {
    next({
      body: response,
      type: USER_LOGIN_REFRESH_SUCCESS,
    });
    return;
  }

  if (response?.error === "jwt expired") {
    next({ type: USER_LOGOUT });
    throw new Error(
      "Your active session has timed out. Request you to re-login",
      {
        cause: "AUTH_FAILED",
      }
    );
  }
}
